import toast from 'react-hot-toast';

// Modern toast configuration
const toastConfig = {
  duration: 4000,
  position: 'top-center',
  style: {
    borderRadius: '8px',
    background: '#FFFFFF',
    color: '#000000',
    fontSize: '14px',
    fontWeight: '500',
    padding: '14px 20px',
    boxShadow: '0 4px 12px rgba(90, 106, 207, 0.15)',
    border: '1px solid #E5E7EB',
    fontFamily: '"Rajdhani", sans-serif',
    minWidth: '300px',
  },
};

// Success toast
export const showSuccess = (message) => {
  toast.success(message, {
    ...toastConfig,
    iconTheme: {
      primary: '#10B981',
      secondary: '#FFFFFF',
    },
    style: {
      ...toastConfig.style,
    },
  });
};

// Error toast
export const showError = (message) => {
  toast.error(message, {
    ...toastConfig,
    iconTheme: {
      primary: '#EF4444',
      secondary: '#FFFFFF',
    },
    style: {
      ...toastConfig.style,
    },
  });
};

// Info toast
export const showInfo = (message) => {
  toast(message, {
    ...toastConfig,
    icon: 'ℹ️',
    style: {
      ...toastConfig.style,
    },
  });
};

// Warning toast
export const showWarning = (message) => {
  toast(message, {
    ...toastConfig,
    icon: '⚠️',
    iconTheme: {
      primary: '#F59E0B',
      secondary: '#FFFFFF',
    },
    style: {
      ...toastConfig.style,
    },
  });
};

const toastUtils = {
  success: showSuccess,
  error: showError,
  info: showInfo,
  warning: showWarning,
};

export default toastUtils;
